module.exports = __webpack_public_path__ + "media/country_flags/bv-83e5f9bb.png";